var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLink = function SvgLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.235 11.293-2.166 2.165a3.552 3.552 0 0 1-5.027 0 3.552 3.552 0 0 1 0-5.027l2.165-2.165.097-.094a.328.328 0 0 1 .553.227c.005.131.016.263.033.393a.33.33 0 0 1-.093.276l-2.06 2.059a2.57 2.57 0 0 0 0 3.635 2.57 2.57 0 0 0 3.636 0l2.166-2.165.01-.01a2.574 2.574 0 0 0-.765-4.148.33.33 0 0 1-.195-.32 1.7 1.7 0 0 1 .077-.416.326.326 0 0 1 .436-.2 3.56 3.56 0 0 1 1.133 5.79Zm-2.47-2.558c.335.334.721.589 1.133.762a.326.326 0 0 0 .436-.2 1.7 1.7 0 0 0 .077-.417.33.33 0 0 0-.195-.319 2.574 2.574 0 0 1-.764-4.148l.01-.01 2.165-2.165a2.57 2.57 0 0 1 3.635 0 2.57 2.57 0 0 1 0 3.635l-2.059 2.059a.33.33 0 0 0-.093.276c.017.13.028.261.034.393a.328.328 0 0 0 .552.227c.033-.03.065-.062.097-.093l2.165-2.166a3.552 3.552 0 0 0 0-5.027 3.552 3.552 0 0 0-5.027 0L5.766 3.707a3.559 3.559 0 0 0 0 5.028Z"
  })));
};
export default SvgLink;